import { CountryCode } from '@checkout/countryCodes';
import { FieldProps } from 'formik';
import { get } from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import IntlTelephoneInput from '../IntlTelephoneInput/IntlTelephoneInput';

interface IOwnProps {
  id: string;
  name: string;
  type: 'text';
  defaultValue: string;
  country: CountryCode;
  onChange: (event: ChangeEvent<any>) => void;
}

const IntlTelField: React.SFC<FieldProps<any> & IOwnProps> = ({
  field,
  country,
  form,
  form: { touched, errors },
  ...props
}) => {
  return (
    <IntlTelephoneInput
      {...field}
      {...props}
      initialCountry={country}
      touched={get(touched, field.name)}
      errors={get(errors, field.name)}
      form={form}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) {
          props.onChange(event);
        }
        field.onChange(event);
      }}
    />
  );
};

export default IntlTelField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/IntlTelField/IntlTelField.tsx